
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/polkadot-blockchain-development",
      function () {
        return require("private-next-pages/polkadot-blockchain-development/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/polkadot-blockchain-development"])
      });
    }
  